import React from 'react';
import styled from 'styled-components';
import { mq, Title } from '@kvdbil/components';
import Section from '~/App/shared/components/Layout/Section';
import { Image } from 'react-datocms';
import {
  DatoTitleTag,
  StructuredTextData
} from '~/App/shared/interfaces/datoCMS';
import StructuredText from '~/App/components/DatoCMS/StructuredText';
import { ResponsiveImage } from '~/config/generated/graphql';
import { Nullable } from '~/App/shared/types/Nullable';

const Container = styled.div<{ $withLogo: boolean }>`
  display: grid;
  ${({ $withLogo }) =>
    $withLogo
      ? `
    grid-template-columns: 30% auto;
    grid-template-areas:
      'logo heading'
      'preamble preamble';
    align-items: center;
    `
      : `
    grid-template-columns: auto;
    grid-template-areas:
      'heading'
      'preamble';
    `};

  ${mq('tablet')} {
    ${({ $withLogo }) =>
      $withLogo &&
      `
      grid-template-columns: 13rem auto;
      align-items: start;
      grid-template-areas:
        'logo heading'
        'logo preamble';
    `};
  }
`;

const LogoWrapper = styled.div`
  margin: 0 1rem;
  grid-area: logo;

  ${mq('tablet')} {
    margin: 0.75rem 3rem 0 3rem;
  }
`;

const Heading = styled(Title)`
  grid-area: heading;
`;

const Preamble = styled.div`
  grid-area: preamble;
`;

const StyledImage = styled.img`
  width: 100%;
`;

interface Props {
  logo?: Nullable<{
    url: string;
    alt?: string | null;
    responsiveImage?: Nullable<ResponsiveImage>;
  }>;
  headingText: string;
  headingTag?: string | null;
  preamble?: Nullable<StructuredTextData>;
}

const HeadingAndPreambleSection = ({
  logo,
  headingText,
  headingTag,
  preamble
}: Props) => {
  return (
    <>
      <Section
        maxWidth={64}
        spacingTop={2.5}
        spacingBottom={4}
        backgroundColor="light"
      >
        <Container $withLogo={Boolean(logo)}>
          {logo && (
            <LogoWrapper>
              {logo?.responsiveImage ? (
                <Image data={logo?.responsiveImage} />
              ) : (
                <StyledImage src={logo?.url} alt={logo?.alt ?? 'logo'} />
              )}
            </LogoWrapper>
          )}
          <Heading as={(headingTag ?? 'h1') as DatoTitleTag}>
            {headingText}
          </Heading>
          <Preamble>
            <StructuredText data={preamble} />
          </Preamble>
        </Container>
      </Section>
    </>
  );
};

export default HeadingAndPreambleSection;
